import {
  Button,
  Hotkey,
  Hotkeys,
  HotkeysTarget, Icon,
  Menu,
  MenuItem,
  Navbar,
  NavbarDivider,
  NavbarGroup
} from '@blueprintjs/core'
import * as ContextMenu from '@blueprintjs/core/lib/cjs/components/context-menu/contextMenu'
/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/core'
import { defer } from 'lodash'
import * as OfflinePluginRuntime from 'offline-plugin/runtime'
import React, { forwardRef, PureComponent, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import { NavLink, Redirect, useHistory } from 'react-router-dom'
import { Key } from '../../helper/classes'
import { globalOnDemandVars } from '../../helper/context'
import { toggleKnowledgeTreeMode, undoManager } from '../../helper/functions'
import { useIsPixelMode } from '../../helper/hooks'
import { SearchAddOn } from '../addon/addons/search'
import { TodoListAddOn } from '../addon/addons/todolist'
import DialogComp from '../commonInterface/dialog'
import SaveState from './saveState'
import { useTranslation } from 'react-i18next'

// const gradientEffect = keyframes`
// {
//     0%{background-position:75% 0%}
//     50%{background-position:25% 100%}
//     100%{background-position:75% 0%}
// }
// `
export const NavBarHeight = 0
// const css1 = css`
//   flex: none; width: 100%; height: ${NavBarHeight}px; z-index: 100; position: relative;
//   background: var(--primary3);
//   background: -moz-linear-gradient(22deg,var(--primary1),var(--primary2),var(--primary3),var(--primary5),#ffffff 1%,var(--primary5),var(--primary1),var(--primary2),var(--primary3),var(--primary5));
//   background: -webkit-linear-gradient(22deg,var(--primary1),var(--primary2),var(--primary3),var(--primary5),#ffffff 1%,var(--primary5),var(--primary1),var(--primary2),var(--primary3),var(--primary5));
//   background: linear-gradient(22deg,var(--primary1),var(--primary2),var(--primary3),var(--primary5),#ffffff 1%,var(--primary5),var(--primary1),var(--primary2),var(--primary3),var(--primary5));
//   background-size: 800% 800% !important;
//
//   animation: ${gradientEffect} 300s ease infinite !important;
// `

function InnerNavbarComp ({ isAnonymous }, ref) {
  const [dialogOpen1, setDialogOpen1] = useState(false)
  const [dialogOpen2, setDialogOpen2] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [dialogChildren, setDialogChildren] = useState(null)
  const [dialogTitle, setDialogTitle] = useState('')
  const [dialogType, setDialogType] = useState(null)
  const [dialogWidth100, setDialogWidth100] = useState(false)

  const { t } = useTranslation()

  useEffect(() => {
    globalOnDemandVars.set_openGlobalDialog((title, children, type, width100) => {
      setDialogTitle(title)
      setDialogChildren(children)
      setDialogOpen(true)
      setDialogType(type)
      setDialogWidth100(width100)
    })
    globalOnDemandVars.set_closeGlobalDialog(() => {
      setDialogOpen(false)
    })
    return () => {
      globalOnDemandVars.set_openGlobalDialog(() => false)
    }
  }, [])

  // const [renderRedirect, setRenderRedirect] = useState(false)
  // const [redirectValue, setRedirectValue] = useState('/')
  // const location = useLocation()
  const history = useHistory()
  const refresh = useCallback(
    () => {
      history.go(0)
    },
    [history]
  )
  useEffect(() => {
    globalOnDemandVars.set_refresh(refresh)
    // return () => {
    //   globalOnDemandVars.set_refresh(() => {})
    // }
  }, [refresh])

  useImperativeHandle(
    ref,
    () => ({
      setDialogOpen1,
      setDialogOpen2,
      refresh
    }),
    [refresh]
  )

  const isPixelMode = useIsPixelMode()
  useEffect(() => {
    globalOnDemandVars.set_isPixelMode(isPixelMode)
  }, [isPixelMode])
  // console.tron.display({
  //   name: 'location-hash의 값',
  //   preview: location.hash,
  //   value: {
  //     location
  //   }
  //   // , important: true
  // })
  return <React.Fragment>
    {/* {renderRedirect ? <Redirect to={redirectValue} /> : null} */}
    {/*    <Navbar onContextMenu={(e) => { e.preventDefault() }}> */}
    {/*      <NavbarGroup css={css`height: 30px; width: 100%; */}
    {/* //&:hover .invisible { */}
    {/* //  visibility: visible; */}
    {/* //} */}
    {/* & .bp3-button { */}
    {/*  height: ${NavBarHeight}px; border: solid rgba(255, 255, 255, 0.5); border-width: 0 1px 0 1px; padding-top: 0; */}
    {/* } */}
    {/* & .buttonIcon { */}
    {/*  font-size: 20px; font-weight: bolder; color: white; letter-spacing: 4px; */}
    {/* } */}
    {/* `}> */}

    {/*        <NavLink to='/organizing' className={'navLinkNormal'} activeClassName='navLinkActive'> */}
    {/*          <Button className={'organizeButton'} minimal icon={<span className={'buttonIcon'}>Organize</span>} /> */}
    {/*        </NavLink> */}
    {/*        /!*        <NavLink to='/pixel' className={'navLinkNormal'} activeClassName='navLinkActive'> *!/ */}
    {/*        /!*          <Button minimal css={css`height: ${NavBarHeight}px; padding: 0; *!/ */}
    {/*        /!* cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAzElEQVRYR+2X0Q6AIAhF5f8/2jYXZkwEjNSVvVUjDpcrGgT7FUkI2D9xRfQETwNIiWO85wfINfQUEyxBG2ArsLwC0jioGt5zFcwF4OYDPi/mBYKm4t0U8ATgRm3ThFoAqkhNgWkA0jJLvaOVSs7j3qMnSgXWBMiWPXe94QqMBMBc1VZIvaTu5u5pQewq0EqNZvIEMCmxAawK0DNkay9QmfFNAJUXfgGgUkLaE7j/h8fnASkxHTz0DGIBMCnBeeM7AArpUd3mz2x3C7wADglA8BcWMZhZAAAAAElFTkSuQmCC) 14 0, pointer !important; *!/ */}
    {/*        /!* `} icon={<div css={css`font-family: 'pixel font' !important; line-height: 1;`}>Play<br />Ground</div>} /> *!/ */}
    {/*        /!*        </NavLink> *!/ */}
    {/*        <NavLink to={() => ((globalOnDemandVars.isMemorizingAlreadyEntered() && globalOnDemandVars.everythingIsAsBefore()) ? '/memorizing' : '/memorizingEnter')} className={'navLinkNormal'} activeClassName='navLinkActive' css={css`margin-left: 8px;`} */}
    {/*          isActive={(match, location) => (match || (location.pathname === '/memorizing' || location.pathname === '/memorizingEnter'))}> */}
    {/*          <Button className={'memorizeButton'} minimal icon={<span className={'buttonIcon'}>Memorize</span>} /> */}
    {/*        </NavLink> */}

    {/*        <NavbarDivider /> */}

    {/*        <NavLink to='/dashboard' className={'navLinkNormal'} activeClassName='navLinkActive'> */}
    {/*          <Button minimal icon={<span className={'buttonIcon'}>Dashboard</span>} /> */}
    {/*        </NavLink> */}

    {/*        {isAnonymous && ( */}
    {/*          <> */}
    {/*            <NavbarDivider /> */}
    {/*            <Button minimal icon={'new-person'} onClick={() => { */}
    {/*              globalOnDemandVars.set_forceSignInPage(true) */}
    {/*            }}><span className={'buttonIcon'}>Sign Up</span></Button> */}
    {/*          </> */}
    {/*        )} */}

    {/*        /!* <a className={'invisible'} href={'https://discord.gg/WYkPZBQeNu'} target={'_blank'}> *!/ */}
    {/*        /!*  <Button minimal css={css`height: ${NavBarHeight}px; padding-top: 0; opacity: 0.7; color: var(--primary5) !important;`} icon={'chat'}> *!/ */}
    {/*        /!*    <span css={css`font-size: 20px; font-weight: bolder; color: white; letter-spacing: 4px;`}>Forum</span> *!/ */}
    {/*        /!*  </Button></a> *!/ */}

    {/*        <span css={css`position: absolute; top: 5px; right: 10px;`}><SaveState /></span> */}

    {/*      </NavbarGroup> */}

    {/*    </Navbar> */}

    <DialogComp isOpen={dialogOpen1} setDialogOpen={setDialogOpen1} title={<div>
      <Icon icon={'tick-circle'} color={'var(--primary3)'} css={css`margin-bottom: var(--s-4);`} />
      {t('To Do List')}
    </div>}>
      <TodoListAddOn withInputFocus forDialog />
    </DialogComp>
    <DialogComp isOpen={dialogOpen2} setDialogOpen={setDialogOpen2} title={'Search'}>
      <SearchAddOn withInputFocus forDialog setDialogOpen={setDialogOpen2} />
    </DialogComp>
    <DialogComp isOpen={dialogOpen} setDialogOpen={setDialogOpen} title={dialogTitle} type={dialogType} width100={dialogWidth100}>
      {dialogChildren}
    </DialogComp>

  </React.Fragment>
}

// eslint-disable-next-line no-func-assign
InnerNavbarComp = forwardRef(InnerNavbarComp)
const altEnter = () => {
  if (!globalOnDemandVars.learningCourseOpened()) {
    globalOnDemandVars.focusToLastNode()() || (globalOnDemandVars.focusToNodeOfCurrentWindow() ? globalOnDemandVars.focusToNodeOfCurrentWindow()() : globalOnDemandVars.focusToNodeOfLastOpenedWindow()())
  }
}

@HotkeysTarget
class NavbarComp extends PureComponent {
  ref = React.createRef()

  _keys = [
    new Key('block alt + right', 'alt + right', () => {}),
    new Key('block alt + left', 'alt + left', () => {}),
    new Key('block alt', 'alt', () => {}),
    new Key('block ctrl+s', 'mod + s', () => {}),
    new Key('toggle knowledgeTreeMode', 'alt + m', () => {
      toggleKnowledgeTreeMode()
    }),
    new Key('Open TodoList', 'alt + t', () => {
      if (!globalOnDemandVars.focusTodoListInput()()) { this.ref.current.setDialogOpen1(true) }
    }),
    new Key('Open Search', 'mod + f', () => {
      if (!globalOnDemandVars.focusSearchInput()()) { this.ref.current.setDialogOpen2(true) }
    }),
    new Key('Update Now', false, async () => {
      await OfflinePluginRuntime.update()
      await OfflinePluginRuntime.applyUpdate()
    }, 'automatic-updates'),
    new Key('Refresh', 'f5', (e) => {
      e && e.stopImmediatePropagation && e.stopImmediatePropagation()
      this.ref.current.refresh()
    }, 'refresh'),
    new Key('Focus on last focused node', 'alt + enter', altEnter),
    new Key('Focus on the node of this window', 'alt + shift + enter', (e) => {
      e && e.stopImmediatePropagation && e.stopImmediatePropagation()
      // console.tron.display({
      //   name: 'NavbarComp focusToNodeOfLastOpenedWindow',
      //   value: {
      //     focusToNodeOfCurrentWindow: globalOnDemandVars.focusToNodeOfCurrentWindow()
      //   }
      //   // , important: true
      // })
      globalOnDemandVars.focusToNodeOfCurrentWindow() ? globalOnDemandVars.focusToNodeOfCurrentWindow()() : globalOnDemandVars.focusToNodeOfLastOpenedWindow()()
    }),
    new Key('Focus on the last opened window', 'mod + alt + shift + enter', (e) => {
      e && e.stopImmediatePropagation && e.stopImmediatePropagation()
      globalOnDemandVars.focusToNodeOfLastOpenedWindow()()
    }),
    new Key('Undo', 'mod + z', () => {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.log('undoredo / undo 0')
      }
      undoManager.undo()
    }, null, null, { notAllowInInput: true }),
    new Key('Redo 1', 'mod + shift + z', () => {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.log('undoredo / redo 0')
      }
      undoManager.redo()
    }, null, null, { notAllowInInput: true }),
    new Key('Redo 2', 'mod + y', () => {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.log('undoredo / redo 1')
      }
      undoManager.redo()
    }, null, null, { notAllowInInput: true })
  ]

  _menu = <Menu>{
    this._keys.map((key) => (!key.isForMenu ? null : (
      <MenuItem {...key.returnPropObjForMenuItem()} />
    )))
  }</Menu>
  onContextMenu = (e) => {
    e.preventDefault()
    e.stopPropagation()

    ContextMenu.show(this._menu, { left: e.clientX, top: e.clientY })
  }

  renderHotkeys = () => {
    return <Hotkeys>{
      this._keys.map((key) => (!key.isForHotKey ? null : (
        <Hotkey {...key.returnPropObjForHotKey()} allowInInput={!key.config.notAllowInInput} global preventDefault />
      )))
    }</Hotkeys>
  }
  render () {
    return (
      <div onContextMenu={this.onContextMenu}><InnerNavbarComp {...this.props} ref={this.ref} keys={this._keys} /></div>
    )
  }
}

export { NavbarComp }
